module.exports = __webpack_public_path__ + "img/pipe4.570f0b03.png";